'use client';

import { useMemo } from 'react';
import { useParams } from 'next/navigation';
import SearchPage from '@/app/search/page';
import type { SearchPageParams } from '@/app/search/types';

/**
 * Collection route now uses the exact same UI/sections as `/search`,
 * with the collection handle pre-applied as a `collection` filter.
 */
export default function CollectionPage() {
  const params = useParams<{ handle: string }>();
  const handle = typeof params?.handle === 'string' ? params.handle : '';

  const searchParams = useMemo<Promise<SearchPageParams>>(
    () => Promise.resolve(handle ? { collection: handle } : {}),
    [handle]
  );

  return <SearchPage searchParams={searchParams} />;
}

